import { useSession } from "@/app/session";
import { PinSection } from "./PinSection";
import { SignOutSection } from "./SignOutSection";
import { profileTitle } from "./profileIdentity";
import { roleLabel } from "./roleLabel";

export function ProfileScreen() {
  const session = useSession();

  return (
    <section className="screen profile">
      <h1 className="shell__heading">{profileTitle(session)}</h1>
      <p className="t-small">{roleLabel(session.user.role)}</p>
      <PinSection />
      <SignOutSection />
    </section>
  );
}
